import type { ActionHandler } from '../types'

export const handleAdvanceSkill: ActionHandler<'ADVANCE_SKILL'> = async (ctx, payload) => {
  const { data: old } = await ctx.supabase
    .from('character_skills')
    .select('skill_name, ml, max_ml')
    .eq('id', payload.skill_id)
    .single()

  if (!old) throw new Error('Skill not found')

  const newMl = Math.min(old.max_ml, old.ml + payload.amount)

  const { error } = await ctx.supabase
    .from('character_skills')
    .update({ ml: newMl })
    .eq('id', payload.skill_id)

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'character_skills',
      target_row_id: payload.skill_id,
      target_field: 'ml',
      operation: 'UPDATE' as const,
      old_value: old.ml,
      new_value: newMl,
    }],
    label: `Advance ${old.skill_name} +${payload.amount} → ML ${newMl}`,
  }
}
